// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"4d95c30a","239":"5290abe1","453":"084830d2","455":"ced920d3"}[chunkId] + ".chunk.js";
};